import React from 'react';
import { ICellRendererParams } from 'ag-grid-community';
import { Button } from '@blueprintjs/core';
import styled from '@emotion/styled';

const CenterContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

interface DeleteCellProps extends ICellRendererParams {
  onDeleteButtonClick: (params: any) => void;
}

class DeleteCell extends React.Component<DeleteCellProps> {
  render() {
    const { onDeleteButtonClick } = this.props;

    return (
      <CenterContainer>
        <Button onClick={onDeleteButtonClick} icon={'delete'} small={true} />
      </CenterContainer>
    );
  }
}

export default DeleteCell;
